import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { FileIcon, getIconForFile } from 'owa-file-icon';
import FileProviderItemViewState, {
    FileProviderItemType,
} from '../store/schema/FileProviderItemViewState';

/* Get icon CSS for file provider item */
export default function getIconCSSForFileProviderItem(
    fileProviderItem: FileProviderItemViewState
): FileIcon {
    if (!fileProviderItem) {
        throw new Error('The file provider item should not be null');
    }

    //Display mail icon for all mail message items
    if (fileProviderItem.model.ProviderType === AttachmentDataProviderType.MailMessage) {
        return getIconForFile('fakeName.msg');
    }

    return getIconForFile(
        fileProviderItem.name,
        fileProviderItem.type === FileProviderItemType.Folder,
        fileProviderItem.model.MimeType
    );
}
